import { render, staticRenderFns } from "./promoter-select.vue?vue&type=template&id=3920e752"
import script from "./promoter-select.vue?vue&type=script&lang=js"
export * from "./promoter-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3920e752')) {
      api.createRecord('3920e752', component.options)
    } else {
      api.reload('3920e752', component.options)
    }
    module.hot.accept("./promoter-select.vue?vue&type=template&id=3920e752", function () {
      api.rerender('3920e752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/selects/promoter-select.vue"
export default component.exports